import './course_nav.css';
import { useLang } from '../../context/LangContext';
import { forwardRef } from "react";

export const CourseNav = forwardRef(({course, setSelectedArticle, selectedArticle, lessonsActive, setLessonsActive}, ref) => {
    const { lang } = useLang();

    return (
        <div className={lessonsActive ? 'course_player_nav active' : 'course_player_nav'}>
            <div className='header'>
                <h1>
                    { course && (course.en && lang === "en" ? course.en.name : course.name) }
                </h1>
            </div>
            <div className='modules'>
                {
                    course && course.modules && course.modules.map(module => {
                        return (
                            <div className='module_container active' key={'course_player_module' + module.id}>
                                <span className='title' onClick={(e) => e.target.parentNode.classList.toggle('active')}>
                                    {module.name}
                                </span>
                                <div className='articles_container'>
                                    {
                                        module.articles && module.articles.map(article => {
                                            return (
                                                <div className={selectedArticle && selectedArticle.id === article.id ? 'item active' : 'item'} key={'course_player_module' + module.id + "_article_" + article.id} onClick={() => {setSelectedArticle(article); setLessonsActive(false); }}>
                                                    <i className="fa-regular fa-newspaper"></i>
                                                    <span>
                                                        {article.name}
                                                    </span>
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
});